<template>
  <div class="BuildABox">
    <div class="build-wrapper">
      <div class="builder-content-wrapper">
        <div id="scroll-container" class="builder-experience-container no-scrollbar">
          <!-- Header Steps -->
          <HeaderSteps 
            :currentStep="currentStep" 
            :canNext="canNext"
            @next-step="handleNextStep"
          />
          
          <!-- Header Actions -->
          <HeaderActions
            :currentStep="currentStep"
            :currentPage="currentPage"
            :canNext="canNext"
            :selectedCardsOccasions="selectedCardsOccasions"
            :currentCopy="currentCopy"
            :currentMobileCopy="currentMobileCopy"
            :headerText="headerText"
            @back="changePage(false)"
            @next="handleNextStep"
            @show-filters="showFilters"
            @show-sort="showSort"
            @leave-builder="leaveBuilder"
          />
          
          <!-- Page Components -->
          <Page3 
            ref="giftsComponent" 
            @leavebuilder="leaveBuilder" 
            @changepage="changePage($event)" 
            v-if="currentPage == 1" 
            @gostep="goStep($event)"
          />
          <Page4 
            @changepage="changePage($event)" 
            v-if="currentPage == 2"
          />
          <Page5 
            ref="cardComponent" 
            @changepage="changePage($event)" 
            @gotoaddonselection="goToAddonSelection" 
            :currentPage="currentPage" 
            v-if="currentPage > 2" 
            @opencart="openCart()"
            @cardwarning="cardWarning()"
          />
        </div>
      </div>
      
      <!-- Side Cart Components -->
      <SideCartNew 
        ref="outSideCart"
        v-show="currentStep > 1"
        :isSticking="isSticking"
        :step="currentStep"
        :fromCard="fromCard"
        @changepage="changePage($event)" 
        @bundle="bundle($event)"
        @gostep="goStep($event)"
        @cardwarning="cardWarning($event)"
        @errormodal="showErrorModal($event)"
      />
      <SideCartMobile 
        v-if="selectedAddonProducts.length > 0" 
        @changepage="changePage($event)" 
        :step="currentStep"
        @bundle="bundle"
      />
    </div>
    
    <!-- Out of Stock Popup -->
    <OOSPopUp
      v-if="oosIsActive"
      :oosProducts="noStockItems" 
      :firstStateProducts="currentStateSelectedAddons"
      :fromSavedCart="fromSavedCart"
      :fromCurated="fromCurated"
      @goback="closeOOSPopUp"
      @continuesaved="continueSaved"
      @continuecurated="continueCurated"
    />
    <div v-if="isLoading">
      <div class="global-spinner-container">
        <div class="global-spinner"></div>
        <p>Please wait while we load your box...</p>
      </div>
    </div>
  </div>
</template>

<script>
import Page3 from './components/Page3.vue';
import Page4 from './components/Page4.vue';
import Page5 from './components/Page5.vue';
import OOSPopUp from './components/OOSPopUp.vue'
import SideCartNew from './components/SideCartNew.vue'
import SideCartMobile from './components/Step2Mobile/SideCartMobile.vue';
import HeaderSteps from './components/HeaderSteps.vue';
import HeaderActions from './components/HeaderActions.vue';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';

require('dotenv').config();

export default {
  name: 'BuildABox',
  
  components: {
    Page3,
    Page4,
    Page5,
    OOSPopUp,
    SideCartNew,
    SideCartMobile,
    HeaderSteps,
    HeaderActions
  },
  
  data() {
    return {
      currentPage: 1,
      noStockItems: [],
      oosIsActive: false,
      fromSavedCart: false,
      fromCurated: false,
      currentStateSelectedAddons: [],
      currentTime: new Date().getTime() / 100,
      isSticking: false,
      fromCard: false,
    }
  },
  
  computed: {
    ...mapGetters([
      'selectedOccasion',
      'addonProducts',
      'selectedAddonProducts',
      'selectedCardsOccasions',
      'currentCapacity',
      'selectedBoxProduct',
      'selectedCardProduct',
      'cardHasMessage',
      'isLoading',
      'message',
      'from'
    ]),
    
    canNext() {
      if (this.currentStep === 1 && this.selectedAddonProducts.length === 0) {
        return false;
      } else if (this.currentStep === 2 && !this.selectedBoxProduct) {
        return false;
      } else if (this.currentStep === 3 && !this.selectedCardProduct) {
        return false;
      }
      return true;
    },
    
    nextError() {
      if (this.currentStep === 2) {
        return `<p class="title">Select a box to continue</p>`;
      } else if (this.currentStep === 3) {
        return `<p class="title">Select a card to continue</p>`;
      }
      return false;
    },
    
    currentStep() {
      if (this.currentPage < 4) {
        return this.currentPage;
      } else {
        return 3;
      }
    },
    
    currentCopy() {
      const copyMap = {
        1: "Pick gifts they will love",
        2: "Dont worry, these will fit your items perfectly!",
        3: "We will handwrite your message for you"
      };
      return copyMap[this.currentPage] || "";
    },
    
    currentMobileCopy() {
      const copyMap = {
        1: "Pick gifts they will love",
        2: "These will fit your items perfectly!",
        3: "We will handwrite your message"
      };
      return copyMap[this.currentPage] || "";
    },
    
    headerText() {
      return "Save Your Box";
    },
    
    breadcrumbText() {
      return `All products > ${this.selectedOccasion}`;
    },
    
    stepText() {
      const stepMap = {
        1: "Pick Gifts",
        2: "Select Box",
        3: "Write Card"
      };
      return stepMap[this.currentPage] || "";
    }
  },
  
  watch: {
    currentCapacity: {
      handler(val, oldVal) {
        if (val > oldVal && this.selectedBoxProduct) {
          if (parseInt(this.selectedBoxProduct.variants[0].option1) < val) {
            this.$store.commit('updateSelectedMainProduct', null);
          }
        }
      },
    }
  },
  
  methods: {
    // Navigation methods
    changePage(increment) {
      if (!this.canNext && increment) {
        this.showErrorModal();
        return;
      }
      
      this.scrollToTop();
      this.logTimeSpent();
      
      if (increment) {
        if(this.currentPage < 4)
        this.currentPage++;
      } else {
        if (this.currentPage === 1) {
          location.href = "/pages/giftboxbuilder";
        } else {
          this.currentPage--;
        }
      }
      
      this.logStepNavigation(`Step ${this.currentStep}`);
      this.adjustHeaderandFooter();
    },
    
    handleNextStep() {
      if (this.currentStep === 3) {
        if(this.selectedCardProduct && !this.cardHasMessage){
          this.cardWarning();
          return;
        }
        else{
          this.openCart();
        }
      } else {
        this.changePage(true);
      }
    },
    
    goToAddonSelection() {
      this.currentPage = 1;
    },
    
    goStep(event) {
      this.currentPage = event;
      if (this.currentPage === 1) {
        this.$nextTick(() => {
          const container = document.getElementById("scroll-container");
          if (container) {
            container.scrollIntoView();
          }
        });
      }
    },
    
    // Cart and builder methods
    cardWarning() {
      if (this.currentPage === 3) {
        this.currentPage = 4;
      }
      this.$store.commit('setShowCardAlert', true);
      this.showErrorModal(`<p class="title">Please write your card message</p>`);
    },
    
    leaveBuilder() {
      const localProducts = this.selectedAddonProducts
        .filter(x => x.tags.every(tag => !tag.includes("QTYMIN")))
        .map(x => ({
          id: x.id,
          v: x.variants[0].id,
          q: x.quantity
        }));
      localStorage.setItem('totalAddons', JSON.stringify(localProducts));
      if(this.selectedBoxProduct){
        localStorage.setItem('selectedBoxProduct', JSON.stringify(this.selectedBoxProduct));
      }
      if(this.selectedCardProduct){
        localStorage.setItem('selectedCardProduct', JSON.stringify({card:this.selectedCardProduct, message: this.message, from: this.from}));
      }
    },
    
    openCart() {
      this.fromCard = true;
      this.$refs.outSideCart.expandCart(true);
    },
    
    bundle(event) {
      if (!this.canNext) {
        this.showErrorModal();
        return;
      }
      if(this.selectedCardProduct && !this.cardHasMessage){
        this.cardWarning();
        return;
      }
      this.$refs.cardComponent.bundle(event);
    },
    
    // UI and utility methods
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'auto' });
      const pageContainer = document.getElementById('PageContainer');
      if (pageContainer) {
        pageContainer.scrollTo({ top: 0, behavior: 'auto' });
      }
    },
    
    adjustHeaderandFooter() {
      const buildBox = document.getElementById('build-a-box');
      const footer = document.getElementById('shopify-section-footer');
      const header = document.getElementById('shopify-section-header');
      const ticker = document.getElementById('ticker');

      if (this.currentPage > 0) {
        if (buildBox) buildBox.style.overflow = 'hidden';
        if (footer) footer.style.display = 'none';
        if (header) header.style.display = 'none';
        if (ticker) ticker.style.display = 'none';
      } else {
        if (buildBox) buildBox.style.overflow = 'auto';
        if (footer) footer.style.display = '';
        if (header) header.style.display = '';
        if (ticker) ticker.style.display = '';
      }
    },
    
    // Out of stock popup methods
    closeOOSPopUp() {
      this.fromSavedCart = false;
      this.fromCurated = false;
      this.noStockItems = [];
      this.oosIsActive = false;
      this.currentStateSelectedAddons = [];
    },
    
    continueSaved() {
      this.closeOOSPopUp();
      this.currentPage = 3;
    },
    
    continueCurated() {
      this.closeOOSPopUp();
      this.changePage(true);
    },
    
    oosCurated(event) {
      this.currentStateSelectedAddons = JSON.parse(JSON.stringify(this.selectedAddonProducts));
      this.fromSavedCart = false;
      this.fromCurated = true;
      this.noStockItems = event;
      this.oosIsActive = true;
    },
    
    // Analytics methods
    logStepNavigation(label) {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'step_navigation', {
          location: 'build-a-box',
          label: label
        });
      }
    },
    
    logTimeSpent() {
      const actualTime = new Date().getTime() / 100;
      if (typeof gtag !== 'undefined') {
        gtag('event', 'time_spent', {
          location: 'build-a-box',
          label: `Time Step ${this.currentStep}`,
          value: actualTime - this.currentTime
        });
      }
      this.currentTime = actualTime;
    },
    
    // Modal and UI methods
    showErrorModal(error = null) {
      Swal.fire({
        iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
        html: error || this.nextError,
        confirmButtonText: 'Go Back',
        customClass: {
          container: "swal-custom-container",
          popup: "swal-custom-popup-3",
          title: "swal-title",
          confirmButton: "happybox-button green border",
        },
        buttonsStyling: false,
      });
    },
    
    showSort() {
      if (this.$refs.giftsComponent) {
        this.$refs.giftsComponent.showSort();
      }
    },
    
    showFilters() {
      if (this.currentStep === 1 && this.$refs.giftsComponent) {
        this.$refs.giftsComponent.showFilters();
      } else if (this.currentStep === 3 && this.$refs.cardComponent) {
        this.$refs.cardComponent.showFilters();
      }
    },
    
    setupIntersectionObserver() {
      const el = document.getElementById("header-actions");
      if (el) {
        const observer = new IntersectionObserver(
          ([e]) => {
            e.target.classList.toggle("isSticky", e.intersectionRatio < 1);
            this.isSticking = e.intersectionRatio < 1;
          },
          { threshold: [1] }
        );
        observer.observe(el);
      }
    }
  },
  
  mounted() {
    this.setupIntersectionObserver();
  },
}
</script>

<style scoped>
.builder-header {
  width: 100%;
  position: relative;
}

.builder-header .header-main {
  width: 100%;
}

.builder-header .floating-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
}

.builder-header.box .floating-container {
  left: 30%;
  width: 20%;
}

.builder-header.card .floating-container {
  left: 30%;
  width: 20%;
  transform: rotate(5deg);
}

.builder-header.card .floating-container .arrow-4 {
  position: absolute;
  bottom: 15%;
  width: 5%;
  transform: rotate(50deg) scaleX(-1);
  left: 5%;
}

.builder-header.box .floating-container .arrow-1 {
  position: absolute;
  width: 5%;
  transform: rotate(115deg);
  left: 20%;
  top: 30%;
}

.builder-header.box .floating-container .arrow-2 {
  position: absolute;
  width: 5%;
  transform: rotate(90deg);
  left: 17%;
  bottom: 25%;
}

.builder-header.box .floating-container .arrow-3 {
  position: absolute;
  width: 5%;
  transform: rotate(-90deg);
  right: 17%;
  bottom: 30%;
}

.builder-header .floating-container .title {
  font-size: 3vw;
  line-height: .5;
  font-family: Palmer Lake Print;
  text-align: center;
}

@media screen and (max-width: 767px) {
  .builder-header .floating-container .title {
    font-size: 8vw;
  }

  .builder-header.box .floating-container {
    left: 50%;
    justify-content: flex-start;
    padding-top: 7%;
    transform: rotate(5deg);
  }

  .builder-header.box .floating-container .arrow-1 {
    width: 12.5%;
    left: -25%;
    top: 35%;
    transform: rotate(90deg);
  }
  
  .builder-header.box .floating-container .arrow-2 {
    width: 12.5%;
    bottom: 15%;
    left: 35%;
    transform: rotate(15deg) scaleX(-1);
  }
  
  .builder-header.box .floating-container .arrow-3 {
    width: 12.5%;
    right: -20%;
    bottom: unset;
    top: 25%;
  }

  .builder-header.card .floating-container {
    left: 35%;
    width: 50%;
    transform: rotate(5deg);
    padding-top: 5%;
    justify-content: flex-start;
  }

  .builder-header.card .floating-container .arrow-4 {
    left: 15%;
    width: 7%;
    transform: rotate(40deg) scaleX(-1);
  }
}
</style>

<style>
#shopify-section-footer,
#shopify-section-header,
#ticker {
  display: none;
}

.global-spinner-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.3);
  position: fixed;
  height: 100%;
  z-index: 999;
  top: 0;
  right: 0;
  left: 0;
}

.global-spinner-container p {
  font-size: 32px;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.global-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

.promotion {
  width: 100%;
  position: relative;
}

.promotion img {
  width: 100%;
  border-radius: 8px;
}

.promotion .floating-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 5%;
}

.promotion .floating-container .title {
  font-size: 2.5vw;
  font-family: Founders Grotesk,sans-serif;
  line-height: 1;
  color: #fff;
  padding-right: 12%;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle {
  font-size: 1vw;
  color: white;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle span {
  font-style: italic;
  color: white;
}

.promotion .floating-container .happybox-button {
  width: 100%;
}

.builder-header .breadcrumb {
  color: #0f0c38;
  text-decoration: underline;
  position: absolute;
  top: 0%;
  left: 5%;
  z-index: 1;
  display: none;
}

.builder-header .breadcrumb > * {
  color: #0f0c38;
  text-decoration: underline;
  font-weight: bold;
}

.BuildABox .next-error-modal {
  width: 50%;
  background-color: white;
  position: fixed;
  left: 25%;
  padding: 5% 2.5%;
  top: 30%;
  border-radius: 8px;
  border: 1px solid #D6D6D6;
  box-shadow: 0 0 3px 0px #00000050;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.BuildABox .next-error-modal img {
  width: 4vw;
}

.BuildABox .next-error-modal p {
  font-size: 2vw;
  font-weight: bold;
}

@media screen and (max-width: 767px) {
  .global-spinner-container p {
    font-size: 27px;
  }
  
  .promotion img {
    height: 100%;
    object-fit: cover;
  }

  .promotion .floating-container .happybox-button {
    width: 100%;
    padding: 2%;
  }

  .promotion .floating-container .title {
    font-size: 5vw;
    width: 100%;
  }

  .promotion .floating-container .subtitle {
    font-size: 2vw;
    width: 100%;
    text-align: left;
  }

  .builder-header .breadcrumb {
    top: 7.5%;
    display: block;
  }

  .BuildABox .next-error {
    font-size: 4vw;
    bottom: calc(50% - 2vw);
    left: 25%;
    width: 50%;
  }
}
</style>